// import React, { useEffect, useState } from "react";
// import toast from "react-hot-toast";
// import RoomCard from "../../components/listings/RoomCard";
// import Pagination from "../../components/common/Pagination";
// import api from "../../utils/api";
// import Button from "../../components/common/Button";
// import { ROOM_TYPE_OPTIONS } from "../../constants/listingOptions";

// export default function SearchRoomsPage() {
//   const [filters, setFilters] = useState({
//     location: "",
//     budget: "",
//     roomType: "",
//   });

//   const [rooms, setRooms] = useState([]);
//   const [loading, setLoading] = useState(false);

//   function handleChange(e) {
//     const { name, value } = e.target;

//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   }

//   async function loadRooms(){
//     setLoading(true);
//     try {
//       const res = await api.get("/listings/search", {
//         params: {
//           availability: true,
//           location: filters.location,
//           budget: filters.budget,
//           roomType: filters.roomType,
//         }
//       });
//       setRooms(res.data);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to load rooms");
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     loadRooms();
//   }, []);

//   return (
//     <div className="max-w-7xl mx-auto px-6 py-4">
//       <h2 className="text-2xl font-semibold">Search Results</h2>
//       <p className="text-gray-500 mb-5">
//         {loading ? "Loading rooms..." : `${rooms.length} rooms found`}
//       </p>

//       {/* Filters */}
//       <div className="bg-white p-1 rounded-2xl shadow-md mt-3 flex items-center gap-4 mb-6">
//         <input
//           name="location"
//           value={filters.location}
//           onChange={handleChange}
//           placeholder="Location"
//           className="flex-1 border rounded-xl p-3"
//         />

//         <input
//           type="number"
//           name="budget"
//           value={filters.budget}
//           onChange={handleChange}
//           placeholder="Budget (NPR)"
//           className="flex-1 border rounded-xl p-3"
//         />

//         <select
//           name="roomType"
//           value={filters.roomType}
//           onChange={handleChange}
//           className="flex-1 border rounded-xl p-3"
//         >
//           <option value="">Room Type</option>
//           {ROOM_TYPE_OPTIONS.map((type) => (
//             <option key={type} value={type}>
//               {type}
//             </option>
//           ))}
//         </select>

//         <Button
//           className="w-40"
//           variant="primary"
//           onClick={loadRooms}
//         >
//           Search Rooms
//         </Button>

//       </div>

//       <div className="grid md:grid-cols-3 gap-5 mt-12">
//         {rooms.map(room => (
//           <RoomCard
//             key={room.id}
//             room={{
//               id: room.id,
//               ownerId: room.ownerId,
//               image: room.images?.[0] || "/images/sample.jpg",
//               title: room.title,
//               location: room.location,
//               price: room.rentAmount
//             }}
//           />
//         ))}
//       </div>

//       {/* Pagination – left static for now */}
//       <Pagination page={1} totalPages={1} onChange={() => {}} />
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import RoomCard from "../../components/listings/RoomCard";
import Pagination from "../../components/common/Pagination";
import api from "../../utils/api";
import Button from "../../components/common/Button";
import { ROOM_TYPE_OPTIONS } from "../../constants/listingOptions";

export default function SearchRoomsPage() {
  const [filters, setFilters] = useState({
    location: "",
    budget: "",
    roomType: "",
  });

  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);

  /*
  |--------------------------------------------------------------------------
  | FILTER CHANGE
  |--------------------------------------------------------------------------
  */

  function handleChange(e) {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  /*
  |--------------------------------------------------------------------------
  | LOAD ROOMS
  |--------------------------------------------------------------------------
  */

  async function loadRooms() {
    setLoading(true);

    try {
      const params = {
        availability: true,
      };

      if (filters.location.trim()) {
        params.location = filters.location.trim();
      }

      if (filters.budget) {
        params.budget = filters.budget;
      }

      if (filters.roomType) {
        params.roomType = filters.roomType;
      }

      const res = await api.get("/listings/search", {
        params,
      });

      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];

      setRooms(data);
    } catch (err) {
      console.error("Failed to load rooms:", err);

      setRooms([]);

      toast.error("Failed to load rooms");
    } finally {
      setLoading(false);
    }
  }

  /*
  |--------------------------------------------------------------------------
  | INITIAL LOAD
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    loadRooms();
  }, []);

  /*
  |--------------------------------------------------------------------------
  | SEARCH
  |--------------------------------------------------------------------------
  */

  function handleSearch(e) {
    e?.preventDefault();

    loadRooms();
  }

  /*
  |--------------------------------------------------------------------------
  | ROOM DATA FORMAT
  |--------------------------------------------------------------------------
  */

  function formatRoom(room) {
    return {
      id: room.id,

      ownerId: room.ownerId,

      image: room.images?.[0] || "/images/sample.jpg",

      title: room.title,

      location: room.location,

      roomType: room.roomType,

      price: room.rentAmount,
    };
  }

  /*
  |--------------------------------------------------------------------------
  | SPLIT ROOMS
  |--------------------------------------------------------------------------
  |
  | First 6 rooms appear before the in-feed advertisement.
  | Remaining rooms appear below it.
  |
  */

  const firstRooms = rooms.slice(0, 6);

  const remainingRooms = rooms.slice(6);

  return (
    <div className="bg-white min-h-screen">
      {/* ================================================================
          MAIN CONTAINER
      ================================================================ */}

      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-6">
        {/* ==============================================================
            PAGE HEADER
        ============================================================== */}

        <div className="mb-5">
          <h1
            className="
            text-2xl
            md:text-3xl
            font-bold
            text-gray-900
          "
          >
            Search Rooms
          </h1>

          <p
            className="
            text-gray-500
            text-sm
            mt-1
          "
          >
            Find a room that matches your requirements.
          </p>
        </div>

        {/* ==============================================================
            SEARCH / FILTER BAR
        ============================================================== */}

        <form
          onSubmit={handleSearch}
          className="
            bg-white
            border
            border-gray-200
            rounded-2xl
            shadow-sm
            p-2
            flex
            flex-col
            md:flex-row
            gap-2
            mb-8
          "
        >
          {/* LOCATION */}

          <input
            name="location"
            value={filters.location}
            onChange={handleChange}
            placeholder="Location"
            className="
              flex-1
              border
              border-gray-200
              rounded-xl
              px-4
              py-3
              text-sm
              outline-none
              focus:ring-2
              focus:ring-orange-400
            "
          />

          {/* BUDGET */}

          <input
            type="number"
            name="budget"
            value={filters.budget}
            onChange={handleChange}
            placeholder="Budget (NPR)"
            className="
              flex-1
              border
              border-gray-200
              rounded-xl
              px-4
              py-3
              text-sm
              outline-none
              focus:ring-2
              focus:ring-orange-400
            "
          />

          {/* ROOM TYPE */}

          <select
            name="roomType"
            value={filters.roomType}
            onChange={handleChange}
            className="
              flex-1
              border
              border-gray-200
              rounded-xl
              px-4
              py-3
              text-sm
              bg-white
              outline-none
              focus:ring-2
              focus:ring-orange-400
            "
          >
            <option value="">Room Type</option>

            {ROOM_TYPE_OPTIONS.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>

          {/* SEARCH BUTTON */}

          <Button type="submit" variant="primary" className="md:w-40">
            Search Rooms
          </Button>
        </form>

        {/* ==============================================================
            CONTENT + ADVERTISEMENT
        ============================================================== */}

        <div
          className="
          grid
          grid-cols-1
          lg:grid-cols-4
          gap-6
        "
        >
          {/* ============================================================
              ROOM DATA
              3 / 4 WIDTH
          ============================================================ */}

          <main className="lg:col-span-3">
            {/* ==========================================================
                RESULTS HEADER
            ========================================================== */}

            <div
              className="
              flex
              items-center
              justify-between
              mb-5
            "
            >
              <div>
                <h2
                  className="
                  text-xl
                  font-semibold
                  text-gray-900
                "
                >
                  Search Results
                </h2>

                <p
                  className="
                  text-sm
                  text-gray-500
                  mt-1
                "
                >
                  {loading ? "Loading rooms..." : `${rooms.length} rooms found`}
                </p>
              </div>
            </div>

            {/* ==========================================================
                LOADING
            ========================================================== */}

            {loading && (
              <div
                className="
                bg-gray-50
                border
                border-gray-200
                rounded-2xl
                py-16
                text-center
              "
              >
                <p className="text-gray-500">Loading available rooms...</p>
              </div>
            )}

            {/* ==========================================================
                NO RESULTS
            ========================================================== */}

            {!loading && rooms.length === 0 && (
              <div
                className="
                bg-gray-50
                border
                border-gray-200
                rounded-2xl
                py-16
                text-center
              "
              >
                <div
                  className="
                  text-4xl
                  mb-3
                "
                >
                  🏠
                </div>

                <h3
                  className="
                  font-semibold
                  text-gray-800
                "
                >
                  No rooms found
                </h3>

                <p
                  className="
                  text-sm
                  text-gray-500
                  mt-1
                "
                >
                  Try changing your location, budget or room type.
                </p>
              </div>
            )}

            {/* ==========================================================
                FIRST ROOM SET
                6 ROOMS
            ========================================================== */}

            {!loading && firstRooms.length > 0 && (
              <div
                className="
                grid
                grid-cols-1
                sm:grid-cols-2
                xl:grid-cols-3
                gap-5
              "
              >
                {firstRooms.map((room) => (
                  <RoomCard key={room.id} room={formatRoom(room)} />
                ))}
              </div>
            )}

            {/* ==========================================================
                IN-FEED ADVERTISEMENT
            ========================================================== */}

            {!loading && rooms.length > 6 && (
              <div className="my-4">
                {/* <AdvertisementBanner /> */}
                <Advertisement
                  src="/images/advertisements/homePage/sidebar-ad.jpeg"
                  alt="RoomVetiyo Advertisement"
                  size="infeed"
                  href="#"
                />
              </div>
            )}

            {/* ==========================================================
                REMAINING ROOMS
            ========================================================== */}

            {!loading && remainingRooms.length > 0 && (
              <div
                className="
                grid
                grid-cols-1
                sm:grid-cols-2
                xl:grid-cols-3
                gap-5
              "
              >
                {remainingRooms.map((room) => (
                  <RoomCard key={room.id} room={formatRoom(room)} />
                ))}
              </div>
            )}

            {/* ==========================================================
                PAGINATION
            ========================================================== */}

            {!loading && rooms.length > 0 && (
              <div className="mt-10">
                <Pagination page={1} totalPages={1} onChange={() => {}} />
              </div>
            )}
          </main>

          {/* ============================================================
              RIGHT SIDEBAR
              1 / 4 WIDTH
          ============================================================ */}
          <aside className="lg:col-span-1">
            <div className="lg:sticky lg:top-24">
              <Advertisement
                src="/images/advertisements/homePage/sidebar-ad.jpeg"
                alt="RoomVetiyo Advertisement"
                size="sidebar"
                href="#"
              />
              <Advertisement
                src="/images/advertisements/homePage/sidebar-ad.jpeg"
                alt="RoomVetiyo Advertisement"
                size="sidebar"
                href="#"
              />
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}

/*
|--------------------------------------------------------------------------
| IN-FEED ADVERTISEMENT
|--------------------------------------------------------------------------
*/

function AdvertisementBanner() {
  return (
    <div className="w-full">
      <div className="relative">
        {/* Banner */}

        <a
          href="#"
          target="_blank"
          rel="noopener noreferrer"
          className="block group"
        >
          <img
            src="/images/advertisements/findHomePage/in-feed-banner.jpeg"
            alt="Advertisement"
            className="w-full h-[100px] md:h-[120px] object-cover rounded-xl border border-gray-200 group-hover:shadow-md transition duration-300"
          />
        </a>
      </div>
    </div>
  );
}

/* ==========================================================================
   ADVERTISEMENT COMPONENT
============================================================================ */

function Advertisement({ src, alt, size = "hero", href }) {
  const sizes = {
    hero: {
      height: "h-[120px] sm:h-[135px] md:h-[150px]",
      label: "1200 × 150 px",
    },

    infeed: {
      height: "h-[100px] sm:h-[110px] md:h-[120px]",
      label: "1200 × 120 px",
    },

    footer: {
      height: "h-[80px] sm:h-[90px] md:h-[100px]",
      label: "1200 × 100 px",
    },

    sidebar: {
      height: "h-[300px] sm:h-[350px] lg:h-[400px]",
      label: "300 × 400 px",
    },
  };

  const currentSize = sizes[size] || sizes.hero;

  return (
    <div className="w-full">
      <div className="relative group">
        {/* Image */}
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="block group"
        >
          <img
            src={src}
            alt={alt}
            className={`w-full ${currentSize.height} object-cover rounded-xl border border-gray-200 group-hover:shadow-lg transition-all duration-300`}
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        </a>
      </div>

      {/* Dimensions */}

      <p className="text-center text-[9px] text-gray-400 mt-4">
        {/* {currentSize.label} */}
      </p>
    </div>
  );
}
